module.exports = __webpack_public_path__ + "sl.svg?f5cb409d2dfc8009c8d8d5d193068358";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/sl.svg
// module id = 1614
// module chunks = 0